import { render, staticRenderFns } from "./rename-custom-lut.vue?vue&type=template&id=7d12fb9a&"
import script from "./rename-custom-lut.vue?vue&type=script&lang=js&"
export * from "./rename-custom-lut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports